<template>
	<div class="font" >
		<b-container fluid>
      <b-row>
        <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>求人一覧</h4>
        </b-col>
        <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
          <AgencyList v-if="isAgency" @update="onUpdateAll" :currentOrg="1"></AgencyList>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols='9' class='mx-auto mt-4'>
          <b-row>
            <b-col cols='4' class='px-0'>
              <h4>全<span class="font-org-right-blue h45 px-1">{{ jobList.length }}</span>件</h4>
            </b-col>
            <b-col cols='3' class='px-0'>
              <b-row>
                <b-col cols='11' class='px-0'>
                  <b-form-input v-model="searchWord" @change="onChangeSearch"  class='table-search-input' placeholder='キーワード検索'></b-form-input>
                </b-col>
                <b-col cols='1' class='px-0'>
                  <b-icon @click='search' class='bg-org-blue p-2 table-search-icon' width='2.4rem' height='2.4rem' icon='search'></b-icon>
                </b-col>
              </b-row>
            </b-col>
<!--             <b-col cols='4' class='pl-5'>
              <b-form-select v-model='selected' class='dirty' :options="emStatusOptions">
                <template #first>
                  <b-form-select-option :value="null" disabled>募集案件名</b-form-select-option>
                </template>
              </b-form-select>
            </b-col> -->
          </b-row>
          <b-row>
          </b-row>

          <b-row class='mt-3'>
            <b-col cols='12' class='px-0 text-center tablewrapper'>
              <b-table
                small
                id="my-table"
                :fixed='false'
                :fields="fields"
                :items="jobList"
                :bordered='true'
                head-variant='light'
                :per-page="perPage"
                :current-page="currentPage"
                class='table-scroll recruit-table'
                tdClass="vertical-middle"
              >
                <template #cell(period)='data'>
                  <div class='text-left my-auto'>
                    <span>{{ format_date_full(data.item.posting_time) }}  {{ format_time(data.item.posting_time) }}</span><br/>
                    <span class='text-red'>{{ format_date_full(data.item.posting_end_time) }} {{ format_time(data.item.posting_end_time) }}</span>
                  </div>
                </template>
                <template #cell(offer_num)='data' class="vertical-middle">
                  <div class="my-auto">
                    <h4 class='pt-1 my-auto'>{{ recuruitInfo[data.item.id]['match'] }}人</h4>
                  </div>
                </template>
                <template #cell(match_status)='data'>
                  <h4 class='pt-1 text-red my-auto'>{{ recuruitInfo[data.item.id]['match'] }} / {{ recuruitInfo[data.item.id]['offer'] }}</h4>
                </template>
                <template #cell(description)='data'>
                  <div class="d-flex justify-content-between px-3 py-0">
                    <div class='text-left'>
                      <p class="mb-0 job-table-content">{{ data.item.title }}</p>
                      <p class="mb-0 job-table-content">●職種: {{ data.item.occupation }} / {{ INDUSTRY_DICTIONARY[data.item.industry] }}</p>
                      <p class="mb-0 job-table-content">●給料: {{ salaryDict[data.item.employment_form] }} {{ data.item.salary_from }} ~ {{ data.item.salary_to }}万  ●勤務地: {{data.item.location}}</p>
                    </div>
                    <div class="text-right my-auto">
                      <b-button pill class='table-delete-button' @click='deleteJob(data.item.id)'>削除</b-button>
                      <router-link :to="'./jobOffer/' + data.item.id + '/edit'">
                        <b-button pill class='table-edit-button'>編集</b-button>
                      </router-link>
                      <router-link :to="'./jobOffer/' + data.item.id">
                        <b-button pill class='table-check-button'>確認</b-button>
                      </router-link>
                    </div>
                  </div>
                </template>
                <template #cell(state)='data'>
                  <div class='select-wrap'>
                    <b-form-select v-model="data.item.state" @change='changeState(data.item.id, data.item.state)' class='dirty table-select' :options="PUBLIC_OPTIONS"></b-form-select>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols='12' class='px-0 mt-3'>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalNums"
                :per-page="perPage"
                first-number
                align="center"
                class='table-pagination-custom'
                prev-class='symbol-button'
                next-class='symbol-button'
                last-class='symbol-button'
                first-class='symbol-button'
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
	</div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import AgencyList from "@/components/Agency/AgencyList"

export default {
	components: { AgencyList },
	data() {
      return{
        idToken: localStorage.idToken,
        jobList: [],
        selected: null,
        searchWord: '',
        emStatusOptions: [
          { value: 'full', text: this.$i18n.t('message.full_time_employee') },
          { value: 'part', text: this.$i18n.t('message.part_time_job') },
          { value: 'temporary', text: this.$i18n.t('message.temporary_staff') },
          { value: 'contract', text: this.$i18n.t('message.contract_employee') },
        ],
        totalNums: 0,
        perPage: 10,
        currentPage: 1,
        fields: [
          { key: 'period', label: '掲載日/期限', tdClass: "vertical-middle" },
          { key: 'offer_num', label: '応募人数', tdClass: "vertical-middle" },
          { key: 'match_status', label: 'マッチ状況', tdClass: "vertical-middle" },
          { key: 'state', label: '公開状況', tdClass: "vertical-middle" },
          { key: 'description', label: '求人内容', tdClass: "vertical-middle" },
        ],
        publicOptions: {
          'public': this.$i18n.t('message.public'),
          'private': this.$i18n.t('message.private')
        },
        occupactionDict: {
            "full": this.$i18n.t('message.full_time_employee'),
            "part": this.$i18n.t('message.part_time_job'),
            "temporary": this.$i18n.t('message.temporary_staff'),
            "contract": this.$i18n.t('message.contract_employee')
        },
        salaryDict: {
          'hourt': '時給' ,
          'week': '週給',
          'month': '月給',
          'year': '年収',
        },
        recuruitInfo: {},
        isAgency: false,
      }
	},
  methods:{
    changeState(job_id, state){
      axios
      .patch(process.env.VUE_APP_API + "/api/org/jobs/" + job_id, {job: { state: state }}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(() => {
      }).catch(error => {
        console.log('this is org error', error)
      })
    },
    onChangeSearch() {
     this.$store.commit('setLoading', true)
     this.fetchJob(this.searchWord)
    },
    format_time(d){
      if(d == undefined) {
        return "--"
      } else {
        return moment(d).format("HH:mm")
      }
    },
    format_date_full(d){
      if(d == undefined){
        return '未設定'
      }
      moment.locale("ja" ,{
        weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
        weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
      });
      return moment(d).format('YYYY/MM/DD (ddd)')
    },
    formatDescription(description){
      var len = description.length
      var result = ''
      for (var i = 0 ; i < Math.floor(len / 25); i++) {
        result += description.slice(25 * i,25 * (i + 1))+ '<br>'
      }
      result += description.slice(25 * i, 25 * i + (len - 25 * i))
      return result
    },
    search(){
      axios
      .get(process.env.VUE_APP_API + "/api/org/jobs?word=" + this.searchWard , {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.jobList = response.data.jobs
        this.totalNums = response.data.meta.total
        this.recuruitInfo = response.data.recuruit
      }).catch(error => {
        console.log('this is org error', error)
      })
    },
    deleteJob(job_id){
      axios
      .delete(process.env.VUE_APP_API + "/api/org/jobs/" + job_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(() => {
        this.jobList = this.jobList.filter(function(row) {
          return row.id != job_id;
        });
        this.$swal({
          title: '削除に成功しました',
          icon: 'info',
        });
      }).catch(error => {
        console.log('this is org error', error)
      })
    },
    fetchJob(w="") {
      axios
        .get(process.env.VUE_APP_API + "/api/org/jobs?word=" + w, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.jobList = response.data.jobs
          this.totalNums = response.data.meta.total
          this.recuruitInfo = response.data.recuruit
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is org error', error)
          this.jobList = []
          this.totalNums = 0
          this.recuruitInfo = {}
          this.$store.commit('setLoading', false)
        })
    },
    checkAgency() {
      var idToken = localStorage.idToken
      axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(() => { this.isAgency = true})
    },
    onUpdateAll() {
      this.$store.commit('setLoading', true)
      this.fetchJob()
    }
  },
  mounted(){
    this.fetchJob()
    this.checkAgency()
  },
}

</script>
<style type="text/css" scoped="">
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
</style>
